export const SET_QUICK_ADD_FOLDER = 'SET_QUICK_ADD_FOLDER';
export const RESET_QUICK_ADD_FOLDER = 'RESET_QUICK_ADD_FOLDER';

export function setQuickAddFolder(folder) {
    return { type: SET_QUICK_ADD_FOLDER, folder };
}

export function resetQuickAddFolder() {
    return { type: RESET_QUICK_ADD_FOLDER };
}
